var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{style:({
    justifyContent: _vm.$store.deviceStartData.firm_style
      .registrator_logo_in_center
      ? 'center'
      : 'flex-start',
    backgroundColor: _vm.$store.registratorBackgroundTopColor,
  })},[_c('img',{staticClass:"company-logo",attrs:{"src":_vm.$store.companyLogoImage}}),(_vm.showLanguageDropdown && _vm.languages.length > 1)?_c('LanguageDropdown',{staticClass:"languages-dropdown",attrs:{"selected-item":_vm.activeLanguage,"languages":_vm.languages},on:{"selectItem":function($event){return _vm.selectLanguage($event)}}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }